import React, { useState } from 'react';
import { VscGame } from 'react-icons/vsc';
import { PlayfulCard, PlayfulCardButton } from '@/components/custom/playful-card';
import { ChallengeCardBanner, ChallengeCardBannerIcon, ChallengeCardBannerText } from '@/components/custom/challenge';
import { ReactComponent as PatternLeft } from '../week-challenge-card/img/pattern-left.svg';
import { ReactComponent as PatternRight } from '../week-challenge-card/img/pattern-right.svg';
import { WeekChallengeModal } from '../week-challenge-modal';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import challengeIcon from '@/assets/images/icons/essay.png';

export function WeekChallengePlayfulCard({ challenge }) {
  const { setCurrentChallenge, setCurrentStep, setRightAnswers, setCurrentRound, setStart, setGeneralCount, setShowQuestionCountDown, setQuestionCountDownTimer } = useWeeklyChallenge();
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setGeneralCount(0);
    setShowModal(false);
    setRightAnswers(0);
    setCurrentRound(1);
    setStart(false);
    setShowQuestionCountDown(false);
    setQuestionCountDownTimer(5);
    setTimeout(() => setCurrentStep(1), 300);
  };

  const handleStart = () => {
    setCurrentChallenge(challenge);
    setShowModal(true);
  };

  return (
    <>
      <PlayfulCard
        badge={{ text: challenge?.taxonomy?.name, variant: 'amber-soft' }}
        className="p-5"
        onClick={challenge?.done ? undefined : handleStart}
      >
        {/* Imagem provisória (mesma do card de redação) até termos uma ilustração definitiva para o desafio da semana. */}
        <img
          src={challengeIcon}
          alt=""
          className="h-20 w-20 object-contain"
        />

        <h3
          className="mb-0 mt-3 line-clamp-3 text-base font-extrabold text-neutral-900"
          title={challenge?.title}
        >
          {challenge?.title}
        </h3>
        <p
          className="mb-0 mt-0.5 truncate text-sm text-neutral-dark"
          title={challenge?.user?.name}
        >
          {challenge?.user?.name}
        </p>

        <div className="mt-auto flex flex-col gap-3 pt-3">
          <ChallengeCardBanner
            className="-mx-5 px-5"
            style={{ '--color-primary': '#C45D14', '--color-primary-light': '#FFA96B', '--color-primary-lighter': '#FFECD8' }}
          >
            <ChallengeCardBannerIcon>
              <PatternLeft />
            </ChallengeCardBannerIcon>
            <ChallengeCardBannerText title={`Ganhe ${challenge?.point} Pontos`}>Ganhe {challenge?.point} Pontos</ChallengeCardBannerText>
            <ChallengeCardBannerIcon>
              <PatternRight />
            </ChallengeCardBannerIcon>
          </ChallengeCardBanner>

          <PlayfulCardButton
            icon={VscGame}
            disabled={challenge?.done}
            onClick={handleStart}
          >
            {challenge?.done ? 'Desafio concluído' : 'Começar desafio'}
          </PlayfulCardButton>
        </div>
      </PlayfulCard>

      <WeekChallengeModal
        show={showModal}
        onClose={handleCloseModal}
      />
    </>
  );
}
